var map = {
	"./codeRedPacket.png": "e809",
	"./color-recording-screen@2x.png": "aec9",
	"./color_icon.png": "6afb",
	"./fileDownload.png": "34bb",
	"./icon-AI.png": "d141",
	"./icon-interact.png": "0f6b",
	"./icon-watch-reward.png": "f58b",
	"./icon_And proved@2x.png": "562c",
	"./icon_Functional@2x.png": "ff87",
	"./icon_Lucky_draw@2x.png": "dc35",
	"./icon_Question@2x.png": "6251",
	"./icon_Sign@2x.png": "81c4",
	"./icon_User statistics@2x.png": "696b",
	"./icon_advertising@2x.png": "7dc4",
	"./icon_appointment@2x.png": "327c",
	"./icon_ban@2x.png": "3363",
	"./icon_brand@2x.png": "dda8",
	"./icon_card.png": "4a4e",
	"./icon_channel.png": "a30d",
	"./icon_chat@2x.png": "5638",
	"./icon_compliance@2x.png": "4efd",
	"./icon_console@2x.png": "5945",
	"./icon_custom@2x.png": "96f9",
	"./icon_data@2x.png": "8f9e",
	"./icon_development@2x.png": "fb05",
	"./icon_document@2x.png": "044f",
	"./icon_embedded@2x.png": "e15e",
	"./icon_envelope@2x.png": "7c19",
	"./icon_exam.png": "23c0",
	"./icon_exceptional@2x.png": "b12a",
	"./icon_gift@2x.png": "6ce3",
	"./icon_goods@2x.png": "45b0",
	"./icon_group@2x.png": "aa28",
	"./icon_information@2x.png": "d270",
	"./icon_interactive@2x.png": "5b98",
	"./icon_invitation@2x.png": "a07b",
	"./icon_languages@2x.png": "fa9b",
	"./icon_like@2x.png": "1848",
	"./icon_mall_reward.png": "bcee",
	"./icon_more.png": "08a1",
	"./icon_notice@2x.png": "0a2f",
	"./icon_playback@2x.png": "c384",
	"./icon_player@2x.png": "b321",
	"./icon_posters@2x.png": "2eea",
	"./icon_public@2x.png": "78be",
	"./icon_questionnaire@2x.png": "541c",
	"./icon_ranking@2x.png": "f5ef",
	"./icon_red_packet.png": "6c77",
	"./icon_registration_form@2x.png": "a2b6",
	"./icon_review.png": "cde9",
	"./icon_role@2x.png": "f6d0",
	"./icon_share@2x.png": "2d53",
	"./icon_shareSetting@2x.png": "d07b",
	"./icon_timing@2x.png": "d123",
	"./icon_video@2x.png": "ce96",
	"./icon_videoSet@2x.png": "734f",
	"./icon_virtual@2x.png": "f01b",
	"./icon_watch@2x.png": "9913",
	"./icon_whea@2x.png": "19d0",
	"./qq.png": "31f0",
	"./service_avatar.png": "3d35",
	"./vh-saas-color-Video.png": "a5bf",
	"./vh-saas-color-mixer-on.png": "1297",
	"./wechat.png": "13ee",
	"./weibo.png": "f55a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db67";